import { useEffect, useRef } from "react";
import { API } from "../api";

// One shared EventSource per browser tab; every subscriber refreshes on events for this business.
const subs = new Set();
let es = null;
let tokenUsed = null;

function connect() {
  const token = localStorage.getItem("kos_token");
  if (!token || typeof EventSource === "undefined") return;
  if (es && tokenUsed === token) return;
  if (es) es.close();
  tokenUsed = token;
  es = new EventSource(`${API}/live/stream?token=${encodeURIComponent(token)}`);
  es.onmessage = (m) => { let kinds = []; try { kinds = JSON.parse(m.data).kinds || []; } catch { /* ignore */ } subs.forEach((f) => f(kinds)); };
  es.onerror = () => { if (es && es.readyState === EventSource.CLOSED) { es = null; setTimeout(() => subs.size && connect(), 5000); } };
}

export function useLive(onEvent, kinds) {
  const ref = useRef(onEvent);
  ref.current = onEvent;
  useEffect(() => {
    const f = (got) => { if (!kinds || got.some((k) => kinds.includes(k))) ref.current(got); };
    subs.add(f); connect();
    return () => { subs.delete(f); if (!subs.size && es) { es.close(); es = null; } };
  }, []); // eslint-disable-line
}
